export const openNewBackgroundTab = (url) => {
  const a = document.createElement("a");
  a.href = url;
  const evt = document.createEvent("MouseEvents");
  evt.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, true, false, false, false, 0, null);
  a.dispatchEvent(evt);
};
